import { render, staticRenderFns } from "./FavoritesList.vue?vue&type=template&id=26dceb26&scoped=true&"
import script from "./FavoritesList.vue?vue&type=script&lang=js&"
export * from "./FavoritesList.vue?vue&type=script&lang=js&"
import style0 from "./FavoritesList.vue?vue&type=style&index=0&id=26dceb26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dceb26",
  null
  
)

export default component.exports